import { IAmenitiesOptions } from "./types";

export const AMENITIES_OPTIONS: IAmenitiesOptions[] = [
  {
    id: "zonaBBQ",
    name: "Zona BBQ",
  },
  {
    id: "communalLiving",
    name: "Salón comunal",
  },
  {
    id: "playground",
    name: "Parque de juegos",
  },
];
